export { borderWidth, BorderWidth } from './borders';
